import { Route } from '@angular/router';
import { hasAuthTypeOrRedirectGuard } from '@rma/authentication/public/util-auth-redirect';
import { RmaEmptyComponent } from '@rma/generic/util/router-utils';
import { NotFoundComponent } from '@rma/layout/status-pages';

import { accountRoutes } from './account';
import { betaRoutes } from './beta.routes';
import { collectRoutes } from './collect';
import { legacyRoutes } from './legacy.routes';
import { monitoringRoutes } from './monitoring';
import { redirectRoutes } from './redirects';
import { settingsRoutes } from './settings';
import { shareRoutes } from './share';

export const globalRoutes: Route[] = [
  {
    path: 'beta',
    children: betaRoutes,
  },
  {
    path: 'connect',
    loadChildren: () => import('@rma/authentication/sso-redirect'),
  },
  {
    path: '',
    canActivate: [hasAuthTypeOrRedirectGuard('non-consumer')],
    children: [
      {
        path: '',
        loadChildren: () => import('@rma/home/overview'),
      },
      {
        path: 'switch-account',
        component: RmaEmptyComponent,
      },
      {
        path: 'no-assistant-access',
        loadComponent: () => import('@rma/assistant-access/public/ui-no-access'),
      },
      {
        path: 'profile',
        loadChildren: () => import('@rma/profile/edit'),
      },
      ...collectRoutes,
      ...shareRoutes,
      ...monitoringRoutes,
      ...settingsRoutes,
      ...accountRoutes,
      ...redirectRoutes,
      ...legacyRoutes,
    ],
  },
  // This needs to be below the other routes because `connect` get swallowed by the `:code`
  {
    path: 'settings/data-feeds/:code',
    loadChildren: () => import('@rma/settings/data-feed-approval'),
  },
  //LEGACY CLEANUP: This route can be removed when we have the dashboard migrated
  {
    path: '',
    title: 'Page not found',
    component: NotFoundComponent,
  },
];
